export const OdontogramGrid = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  background: 'inkMid',
  round: 'Z',
  border: '1px solid inkBorder',
  overflow: 'auto',

  UpperArch: {
    flow: 'x',
    gap: 'X',
    align: 'flex-end center',
    justifyContent: 'center',
    UpperRight: {
      flow: 'x', gap: 'X',
      T18: { extends: 'ToothSVG', state: { num: 18 } },
      T17: { extends: 'ToothSVG', state: { num: 17 } },
      T16: { extends: 'ToothSVG', state: { num: 16 } },
      T15: { extends: 'ToothSVG', state: { num: 15 } },
      T14: { extends: 'ToothSVG', state: { num: 14 } },
      T13: { extends: 'ToothSVG', state: { num: 13 } },
      T12: { extends: 'ToothSVG', state: { num: 12 } },
      T11: { extends: 'ToothSVG', state: { num: 11 } }
    },
    Divider: { width: '2px', height: 'D', background: 'inkBorder', margin: '0 Y' },
    UpperLeft: {
      flow: 'x', gap: 'X',
      T21: { extends: 'ToothSVG', state: { num: 21 } },
      T22: { extends: 'ToothSVG', state: { num: 22 } },
      T23: { extends: 'ToothSVG', state: { num: 23 } },
      T24: { extends: 'ToothSVG', state: { num: 24 } },
      T25: { extends: 'ToothSVG', state: { num: 25 } },
      T26: { extends: 'ToothSVG', state: { num: 26 } },
      T27: { extends: 'ToothSVG', state: { num: 27 } },
      T28: { extends: 'ToothSVG', state: { num: 28 } }
    }
  },

  UpperNumbers: {
    flow: 'x', gap: 'X', justifyContent: 'center',
    UpperRightNums: {
      flow: 'x', gap: 'X',
      N18: { tag: 'span', text: '18', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N17: { tag: 'span', text: '17', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N16: { tag: 'span', text: '16', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N15: { tag: 'span', text: '15', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N14: { tag: 'span', text: '14', fontSize: 'Y', color: 'teal', fontWeight: '600', textAlign: 'center', width: 'C' },
      N13: { tag: 'span', text: '13', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N12: { tag: 'span', text: '12', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N11: { tag: 'span', text: '11', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' }
    },
    NumDivider: { width: '2px', margin: '0 Y' },
    UpperLeftNums: {
      flow: 'x', gap: 'X',
      N21: { tag: 'span', text: '21', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N22: { tag: 'span', text: '22', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N23: { tag: 'span', text: '23', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N24: { tag: 'span', text: '24', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N25: { tag: 'span', text: '25', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N26: { tag: 'span', text: '26', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N27: { tag: 'span', text: '27', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N28: { tag: 'span', text: '28', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' }
    }
  },

  CenterLine: { width: '100%', height: '2px', background: 'inkBorder', margin: 'Y 0' },

  LowerNumbers: {
    flow: 'x', gap: 'X', justifyContent: 'center',
    LowerRightNums: {
      flow: 'x', gap: 'X',
      N48: { tag: 'span', text: '48', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N47: { tag: 'span', text: '47', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N46: { tag: 'span', text: '46', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N45: { tag: 'span', text: '45', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N44: { tag: 'span', text: '44', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N43: { tag: 'span', text: '43', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N42: { tag: 'span', text: '42', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N41: { tag: 'span', text: '41', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' }
    },
    NumDivider: { width: '2px', margin: '0 Y' },
    LowerLeftNums: {
      flow: 'x', gap: 'X',
      N31: { tag: 'span', text: '31', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N32: { tag: 'span', text: '32', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N33: { tag: 'span', text: '33', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N34: { tag: 'span', text: '34', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N35: { tag: 'span', text: '35', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N36: { tag: 'span', text: '36', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N37: { tag: 'span', text: '37', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' },
      N38: { tag: 'span', text: '38', fontSize: 'Y', color: 'inkMuted', textAlign: 'center', width: 'C' }
    }
  },

  LowerArch: {
    flow: 'x', gap: 'X', align: 'flex-start center', justifyContent: 'center',
    LowerRight: {
      flow: 'x', gap: 'X',
      T48: { extends: 'ToothSVG', state: { num: 48 } },
      T47: { extends: 'ToothSVG', state: { num: 47 } },
      T46: { extends: 'ToothSVG', state: { num: 46 } },
      T45: { extends: 'ToothSVG', state: { num: 45 } },
      T44: { extends: 'ToothSVG', state: { num: 44 } },
      T43: { extends: 'ToothSVG', state: { num: 43 } },
      T42: { extends: 'ToothSVG', state: { num: 42 } },
      T41: { extends: 'ToothSVG', state: { num: 41 } }
    },
    Divider: { width: '2px', height: 'D', background: 'inkBorder', margin: '0 Y' },
    LowerLeft: {
      flow: 'x', gap: 'X',
      T31: { extends: 'ToothSVG', state: { num: 31 } },
      T32: { extends: 'ToothSVG', state: { num: 32 } },
      T33: { extends: 'ToothSVG', state: { num: 33 } },
      T34: { extends: 'ToothSVG', state: { num: 34 } },
      T35: { extends: 'ToothSVG', state: { num: 35 } },
      T36: { extends: 'ToothSVG', state: { num: 36 } },
      T37: { extends: 'ToothSVG', state: { num: 37 } },
      T38: { extends: 'ToothSVG', state: { num: 38 } }
    }
  }
}
